import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Coupon from './../models/Coupon';

export function getCoupon(data) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.COUPON_GET,
        parser: (data) => new Coupon(data),
    }).post(data);
}
